/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconCautionSolidComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 512 512">
    <g>
    <g>
        <path d="M501.362,383.95L320.497,51.474c-29.059-48.921-99.896-48.986-128.994,0L10.647,383.95 c-29.706,49.989,6.259,113.291,64.482,113.291h361.736C495.039,497.241,531.068,433.99,501.362,383.95z M256,437.241 c-16.538,0-30-13.462-30-30c0-16.538,13.462-30,30-30c16.538,0,30,13.462,30,30C286,423.779,272.538,437.241,256,437.241z M286,317.241c0,16.538-13.462,30-30,30c-16.538,0-30-13.462-30-30v-150c0-16.538,13.462-30,30-30c16.538,0,30,13.462,30,30 V317.241z" />
    </g>
</g>
  </Icon>
);
};

IconCautionSolidComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Zz4KICAgIDxnPgogICAgICA8cGF0aCBkPSJNNTAxLjM2MiwzODMuOTVMMzIwLjQ5Nyw1MS40NzRjLTI5LjA1OS00OC45MjEtOTkuODk2LTQ4Ljk4Ni0xMjguOTk0LDBMMTAuNjQ3LDM4My45NSBjLTI5LjcwNiw0OS45ODksNi4yNTksMTEzLjI5MSw2NC40ODIsMTEzLjI5MWgzNjEuNzM2QzQ5NS4wMzksNDk3LjI0MSw1MzEuMDY4LDQzMy45OSw1MDEuMzYyLDM4My45NXogTTI1Niw0MzcuMjQxIGMtMTYuNTM4LDAtMzAtMTMuNDYyLTMwLTMwYzAtMTYuNTM4LDEzLjQ2Mi0zMCwzMC0zMGMxNi41MzgsMCwzMCwxMy40NjIsMzAsMzBDMjg2LDQyMy43NzksMjcyLjUzOCw0MzcuMjQxLDI1Niw0MzcuMjQxeiBNMjg2LDMxNy4yNDFjMCwxNi41MzgtMTMuNDYyLDMwLTMwLDMwYy0xNi41MzgsMC0zMC0xMy40NjItMzAtMzB2LTE1MGMwLTE2LjUzOCwxMy40NjItMzAsMzAtMzBjMTYuNTM4LDAsMzAsMTMuNDYyLDMwLDMwIFYzMTcuMjQxeiIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9zdmc+";
IconCautionSolidComponent.Content = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g>
      <path d="M501.362,383.95L320.497,51.474c-29.059-48.921-99.896-48.986-128.994,0L10.647,383.95 c-29.706,49.989,6.259,113.291,64.482,113.291h361.736C495.039,497.241,531.068,433.99,501.362,383.95z M256,437.241 c-16.538,0-30-13.462-30-30c0-16.538,13.462-30,30-30c16.538,0,30,13.462,30,30C286,423.779,272.538,437.241,256,437.241z M286,317.241c0,16.538-13.462,30-30,30c-16.538,0-30-13.462-30-30v-150c0-16.538,13.462-30,30-30c16.538,0,30,13.462,30,30 V317.241z"/>
      </g>
    </g>
  </svg>`;

const IconCautionSolid = styled(IconCautionSolidComponent)``;

export default IconCautionSolid;
